import React from 'react';

export const InputField = ({className, value, onChange, onBlur, label, required, name, type}) => {
    const inputLabel = label && (
        <label>{label}
            {required && <em>*</em>}
        </label>);
    return (
        <div className={className}>
            {inputLabel}
            <input type={type} name={name} value={value} onChange={onChange} onBlur={onBlur}/>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/InputField.js